import React from "react";
import "./ContactScreen.css";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
  Dec,
  auth_token,
  auth_token_name,
  segment_detail_url,
  segment_id_name
} from "../Webcontroller/Webcontroller";
const containerVariants = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.5,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      mass: 0.4,
      damping: 8,
      staggerChildren: 0.5,
      when: "beforeChildren",
    },
  },
};

const childVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

const ContactScreen = () => {
  const [trainData, setTrainData] = useState([]);
  useEffect(() => {
    const trainData = new FormData();
    trainData.append(auth_token_name, auth_token);
    trainData.append(segment_id_name, 25);
    trainData.append(Dec, 0);

    fetch(segment_detail_url, {
      method: "POST",
      body: trainData,
    })
      .then((res) => res.json())
      .then((data) => {
        setTrainData(data.data);
      })
      .catch((error) => { });
  }, []);
  return (
    <div className="bg-div" id="office_contact">
      <div className="container pt-5 pb-5 ">
        <div className="bg-white bg-contact-card">

          {trainData.length > 0 ? (
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <div className=" justify-content-start  pb-5">
                <h3 className=" bg-contact-h3 text-center">Contact Us</h3>

                {trainData.map((item, index) => (
                  <div
                    key={index}
                    className=""
                    
                  >
                    <motion.div
                      variants={childVariants}
                      className="bg-about-p"
                      dangerouslySetInnerHTML={{ __html: item.details }}
                    />
                  </div>


                ))}
              </div>
            </motion.div>
          ) : (
            <div className="d-flex justify-content-center loading-bg">
              <div className="loading-spinner"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactScreen;
